import { useEffect, useState } from 'react';
import { api, type UsageRecord } from '../api';

export default function Usage() {
  const [list, setList] = useState<UsageRecord[]>([]);
  useEffect(() => { void api.usage(200).then(setList); }, []);

  return (
    <div className="p-6">
      <h2 className="mb-4 text-lg font-semibold text-[#272b33]">📈 使用记录</h2>
      <div className="overflow-x-auto rounded-lg border border-[#edeff2] bg-white">
        <table className="w-full text-sm">
          <thead>
            <tr className="border-b border-[#edeff2] text-left text-xs text-[#898b8f]">
              <th className="px-3 py-2">时间</th><th className="px-3 py-2">账户</th><th className="px-3 py-2">模型</th>
              <th className="px-3 py-2">方式</th><th className="px-3 py-2 text-right">Prompt</th><th className="px-3 py-2 text-right">完成</th>
              <th className="px-3 py-2 text-right">耗时</th><th className="px-3 py-2">状态</th>
            </tr>
          </thead>
          <tbody>
            {list.length === 0 && <tr><td colSpan={8} className="px-3 py-6 text-center text-[#bcbdc0]">暂无调用记录</td></tr>}
            {list.map((u, i) => (
              <tr key={i} className="border-b border-[#edeff2]/60 last:border-0">
                <td className="px-3 py-1.5 text-xs text-[#898b8f]">{new Date(u.ts).toLocaleString()}</td>
                <td className="px-3 py-1.5 text-[#565a60]">{u.accountName}</td>
                <td className="px-3 py-1.5 font-mono text-xs text-[#565a60]">{u.model}</td>
                <td className="px-3 py-1.5 text-xs text-[#898b8f]">{u.stream ? '流式' : '普通'}</td>
                <td className="px-3 py-1.5 text-right text-xs text-[#565a60]">{u.promptTokens}</td>
                <td className="px-3 py-1.5 text-right text-xs text-[#565a60]">{u.completionTokens}</td>
                <td className="px-3 py-1.5 text-right text-xs text-[#898b8f]">{(u.ms / 1000).toFixed(1)}s</td>
                <td className="px-3 py-1.5">
                  {u.ok ? <span className="text-[#0bb359]">✓ 成功</span>
                    : <span className="text-[#fa2331]" title={u.error}>✗ 失败{u.error ? ' · ' + u.error : ''}</span>}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}